import { createFileRoute } from '@tanstack/react-router';

// The selected-chat route: a stable chat identity in the URL. The parent
// route renders the viewer; this leaf only encodes the selection.
export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/$interpretationId/chats/$chatId'
)({});
